import { create } from 'zustand';

/**
 * Global open/close state for the Ask ActiveID assistant drawer, so any surface
 * (header button, keyboard shortcut, an "explain this KPI" affordance) can open it.
 * The conversation itself lives in the always-mounted AskAssistantDrawer, so it
 * survives navigation and open/close. `openWith` opens the drawer AND queues a prompt
 * the drawer auto-sends (used by "explain this").
 */
interface AiAssistantState {
  isOpen: boolean;
  pendingPrompt: string | null;
  open: () => void;
  openWith: (prompt: string) => void;
  close: () => void;
  toggle: () => void;
  setOpen: (open: boolean) => void;
  /** Returns the queued prompt (if any) and clears it. */
  consumePendingPrompt: () => string | null;
}

export const useAiAssistantStore = create<AiAssistantState>((set, get) => ({
  isOpen: false,
  pendingPrompt: null,
  open: () => set({ isOpen: true }),
  openWith: (prompt) => set({ isOpen: true, pendingPrompt: prompt }),
  close: () => set({ isOpen: false }),
  toggle: () => set((state) => ({ isOpen: !state.isOpen })),
  setOpen: (isOpen) => set({ isOpen }),
  consumePendingPrompt: () => {
    const p = get().pendingPrompt;
    if (p !== null) set({ pendingPrompt: null });
    return p;
  },
}));
